import RsaHome from "../index.js";

const routes = [
    {
        name: "RsaHome",
        path: "/homersa",
        component: RsaHome.RsaHomeConsegne,
        meta: { title: " Home" },
    },
];

export default routes;
